import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'keepHtml', pure: false })
export class EscapeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(content) {
    this.sanitizer.bypassSecurityTrustResourceUrl('http://www.gdm.gent/trots/');
    const doc = new DOMParser().parseFromString(content, 'text/html');

    return this.sanitizer.bypassSecurityTrustHtml(doc.documentElement.textContent);
  }
}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/utilities/pipes/keep-html.pipe.ts